import { render, staticRenderFns } from "./paymentStatistics.vue?vue&type=template&id=1fa38278&scoped=true"
import script from "./paymentStatistics.vue?vue&type=script&lang=js"
export * from "./paymentStatistics.vue?vue&type=script&lang=js"
import style0 from "./paymentStatistics.vue?vue&type=style&index=0&id=1fa38278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa38278",
  null
  
)

export default component.exports